import * as React from 'react';
import { IconProps } from '../types';

const IcReplace = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22' fill='none' {...props}>
    <path
      d='M21.0885 0H11.9195C11.4156 0 11.0027 0.412599 11.0027 0.916797V6.41812C11.0027 6.92231 11.4156 7.33491 11.9195 7.33491H21.0885C21.5925 7.33491 22.0053 6.92231 22.0053 6.41812V0.916797C22.0053 0.412599 21.5925 0 21.0885 0ZM20.1715 5.50132H12.8365V1.83386H20.1715V5.50132Z'
      fill={props.fill || '#1D2129'}
    />
    <path
      d='M10.0859 14.6704H0.916858C0.412929 14.6704 6.10352e-05 15.083 6.10352e-05 15.5869V21.0883C6.10352e-05 21.5927 0.412929 22.0053 0.916858 22.0053H10.0859C10.5898 22.0053 11.0027 21.5927 11.0027 21.0883V15.5869C11.0027 15.083 10.5898 14.6704 10.0859 14.6704ZM9.16884 20.1717H1.83392V16.504H9.16884V20.1717Z'
      fill={props.fill || '#1D2129'}
    />
    <path
      d='M6.41925 4.58433H9.16884V2.75073H6.41925C4.39397 2.75073 2.75072 4.39205 2.75072 6.41738V9.70636L1.29674 8.25313L6.10352e-05 9.54954L3.01945 12.5678C3.37676 12.9262 3.95768 12.9262 4.31612 12.5678L7.33551 9.54873L6.03856 8.25205L4.58458 9.7063L4.58539 6.41733C4.58539 5.40458 5.4065 4.58433 6.41925 4.58433Z'
      fill={props.fill || '#1D2129'}
    />
    <path
      d='M18.9859 9.43754C18.6286 9.07941 18.0476 9.07941 17.6892 9.43754L14.6701 12.4569L15.9668 13.7533L17.4207 12.2991L17.4199 15.5881C17.4199 16.6009 16.5989 17.4211 15.5861 17.4211H12.8365V19.2547H15.5861C17.6114 19.2547 19.2546 17.6134 19.2546 15.5881V12.2991L20.7086 13.7523L22.0053 12.4558L18.9859 9.43754Z'
      fill={props.fill || '#1D2129'}
    />
  </svg>
);

export default IcReplace;
